import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=2fc7c682&"
import script from "./CustomerEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports